import React from 'react';
export const RestrictedHours = React.lazy(() => import('./RestrictedHours'));